import { useNavigate, useParams } from 'react-router-dom';
import { useAtom } from 'jotai';
import coursePartService, { partsListAtom } from 'src/coursepart/CoursePartService';
import LnIcon from '../LnIcon';
import classes from "./SideBar.module.scss";
import CoursesPanel from './CoursesPanel';
import { useEffect, useState } from 'react';
import { CoursePartWithConnectedDTO } from 'src/coursepart/domain/GetCoursepartsResponse';
import { Link } from 'react-router-dom';
import {   currentUserReadOnlyAtom } from 'src/services/user/userService';


export default function SideBar(props: { setOpenSideBar: (state: boolean) => void }) {
    const navigate = useNavigate();

    const { partId } = useParams();

    const [partList] = useAtom(partsListAtom);

    const [filteredList, setFilteredList] = useState<CoursePartWithConnectedDTO[]>([]);

    useEffect(() => {
        setFilteredList(partList.filter(p => !p.OpenFromCourse));
    }, [partList]);


    return (
        <div className={`m-4 `}>

            <Link to="/" className={`${classes.topIcon}`} >
                <img src="/imgs/logo-author.svg" />
            </Link>

            <div className='toggle'>
                <button className='btn btn-link p-3' onClick={() => props.setOpenSideBar(false)}>
                    <LnIcon name="previous-2" className='icon-small filter-green' />
                </button>
            </div>


            <CoursesPanel />


        </div>
    )
}
